import "../../styles/ResourceLandingPage.scss"

const EducationResourceEmptyResults = ({searchTerm, t}) => {
    return (
        <div className="results-empty">
            {searchTerm ? (
                <>
                    <h1>{t('no-results-were-found')}</h1>
                    <span>{t('no-results-were-found')} {t('that-matched-the-keywords')}{searchTerm}</span>
                </>
                ): (
                <>
                    <h1>{t('no-results-were-found')}</h1>
                    <span>{t('no-results-were-found')} {t('that-matched-the-selections')}</span>
                </>
            )}
        </div>
    );
};

export default EducationResourceEmptyResults;